import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: [] // Holds list of active customers
};

export const customerSlice = createSlice({
  name: 'customerSliceName',
  initialState,
  reducers: {
    getCustomer: (state) => {
      state.loading = true;
      state.error = null;
    },
    successCustomer: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.callTimes += 1;
    },
    failedCustomer: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addCustomer: () => {},
    removeCustomer: () => {},
    updateCustomer: () => {},
    getOneCustomer: () => {},
    searchByMobile: () => {}
  }
});

export const { addCustomer, removeCustomer, updateCustomer, getCustomer, successCustomer, failedCustomer, getOneCustomer, searchByMobile } =
  customerSlice.actions;

export default customerSlice.reducer;
